module.exports = __webpack_public_path__ + "img/AdelleSansSAGE-Bold.2512b138.svg";